import { t } from "@lingui/macro";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Carousel from "~/components/Carousel/Carousel";
import { Stack } from "~/guidelines/Flex";
import SectionTitle from "~/guidelines/SectionTitle";
import { useIsMobileDevice } from "~/guidelines/Theme/mediaQueries";
import LogoKpmg from "~/pages/investisseurs/_assets/our-partners/KPMG.svg";
import LogoCdcHabitat from "~/pages/investisseurs/_assets/our-partners/cdc-habitat.png";
import LogoEternam from "~/pages/investisseurs/_assets/our-partners/eternam.png";
import LogoFianciereSaintJames from "~/pages/investisseurs/_assets/our-partners/financiere-st-james.png";
import LogoGrandEst from "~/pages/investisseurs/_assets/our-partners/grand-est.png";

const Container = styled(Stack)`
  align-items: center;
  margin: 32px 0;
  gap: ${({ theme }) => theme.spacing(6)};
  width: 100%;
  swiper-slide {
    max-width: 256px;
  }
  @media (min-width: 1200px) {
    margin: 80px auto;
    gap: ${({ theme }) => theme.spacing(8)};
  }
`;

const LogoWrapper = styled.div`
  width: 100%;
  height: 236px;
  background-color: ${({ theme }) => theme.color.background.lightFirst};
  padding: 40px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;

  @media (min-width: 1200px) {
    width: 256px;
  }
`;

const SwiperWrapper = styled.div`
  width: 100%;
`;

const OurPartners = () => {
  const isMobile = useIsMobileDevice();
  const [offsetValue, setOffsetValue] = useState(16);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const windowWidth = window.innerWidth;
      // Si l'écran est plus grand que 1440px, calculer la marge, sinon utiliser 16px
      setOffsetValue(windowWidth > 1200 ? (windowWidth - 1200) / 2 : 16);
    }
  }, []);

  const LOGOS = [
    LogoEternam,
    LogoFianciereSaintJames,
    LogoCdcHabitat,
    LogoKpmg,
    LogoGrandEst,
  ];

  return (
    <Container>
      <SectionTitle
        variant="normal"
        firstPart={t`our_plural`}
        secondPart={t`Partners`}
        center="all"
      />

      <SwiperWrapper>
        <Carousel
          items={LOGOS}
          centered={isMobile ? true : false}
          group={isMobile ? 1 : 4}
          offsetBefore={offsetValue}
        >
          {(Logo, idx) => (
            <LogoWrapper>
              <Image
                src={Logo}
                alt={`Logo partenaire ${idx + 1}`}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  width: "auto",
                  height: "auto",
                  objectFit: "contain",
                }}
              />
            </LogoWrapper>
          )}
        </Carousel>
      </SwiperWrapper>
    </Container>
  );
};

export default OurPartners;
